<script>
import Layout from '../layouts/main';
import PageHeader from '@/components/page-header';
import axios from 'axios';
import moment from 'moment';
import { authFackMethods } from '@/state/helpers';

export default {
	page: {
		title: 'Resources',
		meta: [
			{
				name: 'Resources',
			},
		],
	},
	components: { Layout, PageHeader },
	data() {
		return {
			title: '',
			items: [
				{
					text: '',
					href: '/',
				},
			],
			preservePage: 1,
			pageLimit: 30,
			assignedUsers: {},
			unAssignedUsers: {},
			inActiveUsers: {},
			archiveUsers: {},
			buildingsAssigned: {},
			buildingsUnAssigned: {},
			buildingsInActive: {},
			buildingsArchived: {},
			locations: {},
			applicationStatuses: [
				{ value: 'Application Approved', text: 'Application Approved' },
				{ value: 'Assign Applicant', text: 'Assign Applicant' },
				{ value: 'Character Reference Confirmed', text: 'Character Reference Confirmed' },
				{ value: 'Check Fingerprinting Status', text: 'Check Fingerprinting Status' },
				{ value: 'Confirm (ROI) Release of Information Signature', text: 'Confirm (ROI) Release of Information Signature' },
				{ value: 'Confirm Application Status', text: 'Confirm Application Status' },
				{ value: 'Confirm Assignment Date/Role', text: 'Confirm Assignment Date/Role' },
				{ value: 'Confirm DHS Status', text: 'Confirm DHS Status' },
				{ value: 'Confirm Fingerprinting with Applicant', text: 'Confirm Fingerprinting with Applicant' },
				{ value: 'Confirm Meeting Date', text: 'Confirm Meeting Date' },
				{ value: 'Confirm Onboarding Complete', text: 'Confirm Onboarding Complete' },
				{ value: 'Confirm Intellicorps Background Status', text: 'Confirm Intellicorps Background Status' },
				{ value: 'Document Case Details', text: 'Document Case Details' },
				{ value: 'Document Introduction Date/Client', text: 'Document Introduction Date/Client' },
				{ value: 'Email Applicant Background Information to CCM', text: 'Email Applicant Background Information to CCM' },
				{ value: 'Feedback on Assignment', text: 'Feedback on Assignment' },
				{ value: 'Follow-up on Check Fingerprinting Status', text: 'Follow-up on Check Fingerprinting Status' },
				{ value: 'Introduce Applicant to Client', text: 'Introduce Applicant to Client' },
				{ value: 'Orientation / Intro Meeting Complete', text: 'Orientation / Intro Meeting Complete' },
				{ value: 'Orientation Completed', text: 'Orientation Completed' },
				{ value: 'Remove SS and DL', text: 'Remove SS and DL' },
				{ value: 'Review Application', text: 'Review Application' },
				{ value: 'Review Application / Waitlist', text: 'Review Application / Waitlist' },
				{ value: 'Review Character References', text: 'Review Character References' },
				{ value: 'Schedule first Assignment', text: 'Schedule first Assignment' },
				{ value: 'Schedule Orientation / Intro Meeting', text: 'Schedule Orientation / Intro Meeting' },
				{ value: 'Screening Meeting (Phone Call)', text: 'Screening Meeting (Phone Call)' },
				{ value: 'Screening Meeting (Phone Call)', text: 'Screening Meeting (Phone Call)' },
				{ value: 'Screening Meeting Complete', text: 'Screening Meeting Complete' },
				{ value: 'Send Application Received Email', text: 'Send Application Received Email' },
				{ value: 'Send Application Response and DHS email', text: 'Send Application Response and DHS email' },
				{ value: 'Send Assignment Email', text: 'Send Assignment Email' },
				{ value: 'Send assignment email to mentor/CCM', text: 'Send assignment email to mentor/CCM' },
				{ value: 'Send Calendar Invite', text: 'Send Calendar Invite' },
				{ value: 'Send DHS & Orientation email', text: 'Send DHS & Orientation email' },
				{ value: 'Send DHS email', text: 'Send DHS email' },
				{ value: 'Send Fingerprinting instructions email', text: 'Send Fingerprinting instructions email' },
				{ value: 'Send Meeting Invite Email to Applicant', text: 'Send Meeting Invite Email to Applicant' },
				{ value: 'Send Orientation confirmation email', text: 'Send Orientation confirmation email' },
				{ value: 'Start DHS Background Check', text: 'Start DHS Background Check' },
				{ value: 'Start DHS Background Check (NetStudy 2.0)', text: 'Start DHS Background Check (NetStudy 2.0)' },
				{ value: 'Start Intellicorps Background Check', text: 'Start Intellicorps Background Check' },
				{ value: 'State ID, Authorization Form, Date of Orientation Received', text: 'State ID, Authorization Form, Date of Orientation Received' },
				{ value: 'Upload DHS determination letter to R Drive', text: 'Upload DHS determination letter to R Drive' },
			],
			isName: false,
			isLocation: false,
			isUserType: false,
			isSearching: false,
			searchByAssignedUser: '',
			isLoading: false,
			noRecord: false,
			hasAssignedSearched: false,
			hasUnAssignedSearched: false,
			hasInActiveSearched: false,
			hasArchiveSearched: false,

			assignSort: {
				isSorted: true,
				sortKey: 'users.assignment_date',
				sortValue: 'desc',
			},

			unAssignSort: {
				isSorted: false,
				sortKey: null,
				sortValue: null,
			},

			inActiveSort: {
				isSorted: false,
				sortKey: null,
				sortValue: null,
			},

			archiveSort: {
				isSorted: false,
				sortKey: null,
				sortValue: null,
			},

			isNameUnAssigned: false,
			isLocationUnAssigned: false,
			isUserTypeUnAssigned: false,
			isSearchingUnAssigned: false,
			searchByUnAssignedUser: '',
			isLoadingUnAssignedUser: false,
			noRecordUnAssignedUser: false,

			isNameInActive: false,
			isLocationInActive: false,
			isUserTypeInActive: false,
			isSearchingInActive: false,
			searchByInActiveUser: '',
			isLoadingInActiveUser: false,
			noRecordInActiveUser: false,
			noRecordArchive: false,
			isLoadingArchive: false,
			currentUserData: JSON.parse(localStorage.getItem('user')),
			searchFormAssignUser: {
				username: null,
				email: null,
				location: null,
				building: null,
				user_type_id: null,
			},
			searchFormUnAssignUser: {
				username: null,
				email: null,
				location: null,
				building: null,
				user_type_id: null,
			},
			searchFormInActiveUser: {
				username: null,
				email: null,
				location: null,
				building: null,
				user_type_id: null,
				application_status: null,
			},
			searchFormArchiveUser: {
				username: null,
				email: null,
				location: null,
				building: null,
				user_type_id: null,
				user_status_id: null,
			},
			profileStatuses: [
				{ value: '0', text: 'InActive' },
				{ value: '2', text: 'Not A Fit' },
				{ value: '3', text: 'Not 2 Years Sober' },
				{ value: '4', text: 'Do Not Contact' },
				{ value: '5', text: 'Final Incomplete / Expired' },
				{ value: '6', text: 'DHS Not Approved Final' },
				{ value: '12', text: 'PSV Not Approved' },
				{ value: '13', text: 'N/A' },
			],
		};
	},
	mounted() {
		this.getLocations();
	},
	methods: {
		...authFackMethods,
		setAssignedUserTypeIds(e) {
			if (e.target.checked === true) {
				this.searchFormAssignUser.user_type_id.push(e.target.value);
			} else {
				const index = this.searchFormAssignUser.user_type_id.indexOf(e.target.value);
				this.searchFormAssignUser.user_type_id.splice(index, 1);
			}
		},
		setUnAssignedUserTypeIds(e) {
			if (e.target.checked === true) {
				this.searchFormUnAssignUser.user_type_id.push(e.target.value);
			} else {
				const index = this.searchFormUnAssignUser.user_type_id.indexOf(e.target.value);
				this.searchFormUnAssignUser.user_type_id.splice(index, 1);
			}
		},
		setInActiveUserTypeIds(e) {
			if (e.target.checked === true) {
				this.searchFormInActiveUser.user_type_id.push(e.target.value);
			} else {
				const index = this.searchFormInActiveUser.user_type_id.indexOf(e.target.value);
				this.searchFormInActiveUser.user_type_id.splice(index, 1);
			}
		},
		setArchiveUserTypeIds(e) {
			if (e.target.checked === true) {
				this.searchFormArchiveUser.user_type_id.push(e.target.value);
			} else {
				const index = this.searchFormArchiveUser.user_type_id.indexOf(e.target.value);
				this.searchFormArchiveUser.user_type_id.splice(index, 1);
			}
		},
		dateForatter(date) {
			if (date === null || date === '0000-00-00') {
				return '';
			}
			return moment(date, 'YYYY-MM-DD').format('MM/DD/YYYY');
		},
		getAssignedUsers(page) {
			this.hasAssignedSearched = true;
			this.isLoading = true;
			this.noRecord = false;
			if (typeof page === 'undefined') {
				page = 1;
			}
			this.preservePage = page;
			let filter = '&per_page=' + this.pageLimit;
			if (this.searchFormAssignUser.username) {
				filter += '&username=' + this.searchFormAssignUser.username;
			}
			if (this.searchFormAssignUser.email) {
				filter += '&email=' + this.searchFormAssignUser.email;
			}
			if (this.searchFormAssignUser.location) {
				filter += '&location=' + this.searchFormAssignUser.location;
			}
			if (this.searchFormAssignUser.building) {
				filter += '&building=' + this.searchFormAssignUser.building;
			}
			if (this.searchFormAssignUser.user_type_id) {
				filter += '&user_type_id=' + this.searchFormAssignUser.user_type_id;
			}
			// if CCM
			if (this.currentUserData.user_type_id == 7) {
				filter += '&user_type_id=' + 3;
			}

			//if not admin
			if (this.currentUserData.user_type_id !== 1) {
				filter += '&locations=yes';
				filter += '&user_id=' + this.currentUserData.id;
			}

			if (this.assignSort.isSorted) {
				filter += '&sort_key=' + this.assignSort.sortKey;
				filter += '&sort_value=' + this.assignSort.sortValue;
			}

			axios
				.get('admin/users/all/assigned?pagination=true&page=' + page + filter)
				.then((res) => {
					this.assignedUsers = res.data.response;
					this.isLoading = false;
					if (!this.assignedUsers.data.length) {
						this.noRecord = true;
						if (page > 1) {
							this.getAssignedUsers(page - 1);
						}
					}
				})
				.catch((err) => {
					if (err.response) {
						if (err.response.status == 401) {
							this.logout();
						}
					}
				});
		},
		getUnAssignedUsers(page) {
			this.isLoadingUnAssignedUser = true;
			this.noRecordUnAssignedUser = false;
			if (typeof page === 'undefined') {
				page = 1;
			}
			this.preservePage = page;
			let filter = '&per_page=' + this.pageLimit;
			if (this.searchFormUnAssignUser.username) {
				filter += '&username=' + this.searchFormUnAssignUser.username;
			}
			if (this.searchFormUnAssignUser.email) {
				filter += '&email=' + this.searchFormUnAssignUser.email;
			}
			if (this.searchFormUnAssignUser.location) {
				filter += '&location=' + this.searchFormUnAssignUser.location;
			}
			if (this.searchFormUnAssignUser.building) {
				filter += '&building=' + this.searchFormUnAssignUser.building;
			}
			if (this.searchFormUnAssignUser.user_type_id) {
				filter += '&user_type_id=' + this.searchFormUnAssignUser.user_type_id;
			}
			// if CCM
			if (this.currentUserData.user_type_id == 7) {
				filter += '&user_type_id=' + 3;
			}

			//if not admin
			if (this.currentUserData.user_type_id !== 1) {
				filter += '&locations=yes';
				filter += '&user_id=' + this.currentUserData.id;
			}

			if (this.unAssignSort.isSorted) {
				filter += '&sort_key=' + this.unAssignSort.sortKey;
				filter += '&sort_value=' + this.unAssignSort.sortValue;
			}

			axios.get('admin/users/all/unassigned?pagination=true&page=' + page + filter).then((res) => {
				this.unAssignedUsers = res.data.response;
				this.isLoadingUnAssignedUser = false;
				if (!this.unAssignedUsers.data.length) {
					this.noRecordUnAssignedUser = true;
					if (page > 1) {
						this.getUnAssignedUsers(page - 1);
					}
				}
			});
		},
		getInActiveUsers(page) {
			this.isLoadingInActiveUser = true;
			this.noRecordInActiveUser = false;
			if (typeof page === 'undefined') {
				page = 1;
			}
			this.preservePage = page;
			let filter = '&per_page=' + this.pageLimit;
			if (this.searchFormInActiveUser.username) {
				filter += '&username=' + this.searchFormInActiveUser.username;
			}
			if (this.searchFormInActiveUser.email) {
				filter += '&email=' + this.searchFormInActiveUser.email;
			}
			if (this.searchFormInActiveUser.location) {
				filter += '&location=' + this.searchFormInActiveUser.location;
			}
			if (this.searchFormInActiveUser.building) {
				filter += '&building=' + this.searchFormInActiveUser.building;
			}
			if (this.searchFormInActiveUser.user_type_id) {
				filter += '&user_type_id=' + this.searchFormInActiveUser.user_type_id;
			}
			if (this.searchFormInActiveUser.application_status) {
				filter += '&application_status=' + encodeURIComponent(this.searchFormInActiveUser.application_status);
			}

			//if not admin
			if (this.currentUserData.user_type_id !== 1) {
				filter += '&locations=yes';
				filter += '&user_id=' + this.currentUserData.id;
			}

			if (this.inActiveSort.isSorted) {
				filter += '&sort_key=' + this.inActiveSort.sortKey;
				filter += '&sort_value=' + this.inActiveSort.sortValue;
			}

			axios.get('admin/users/all/inactive?pagination=true&page=' + page + filter).then((res) => {
				this.inActiveUsers = res.data.response;
				this.isLoadingInActiveUser = false;
				if (!this.inActiveUsers.data.length) {
					this.noRecordInActiveUser = true;
					if (page > 1) {
						this.getInActiveUsers(page - 1);
					}
				}
			});
		},
		getArchiveUsers(page) {
			this.isLoadingArchive = true;
			this.noRecordArchive = false;
			if (typeof page === 'undefined') {
				page = 1;
			}
			this.preservePage = page;
			let filter = '&per_page=' + this.pageLimit;
			if (this.searchFormArchiveUser.username) {
				filter += '&username=' + this.searchFormArchiveUser.username;
			}
			if (this.searchFormArchiveUser.email) {
				filter += '&email=' + this.searchFormArchiveUser.email;
			}
			if (this.searchFormArchiveUser.location) {
				filter += '&location=' + this.searchFormArchiveUser.location;
			}
			if (this.searchFormArchiveUser.building) {
				filter += '&building=' + this.searchFormArchiveUser.building;
			}
			if (this.searchFormArchiveUser.user_type_id) {
				filter += '&user_type_id=' + this.searchFormArchiveUser.user_type_id;
			}
			if (this.searchFormArchiveUser.user_status_id) {
				filter += '&user_status_id=' + this.searchFormArchiveUser.user_status_id;
			}
			//if not admin
			if (this.currentUserData.user_type_id !== 1) {
				filter += '&locations=yes';
				filter += '&user_id=' + this.currentUserData.id;
			}

			if (this.archiveSort.isSorted) {
				filter += '&sort_key=' + this.archiveSort.sortKey;
				filter += '&sort_value=' + this.archiveSort.sortValue;
			}

			axios.get('admin/users/all/archive?pagination=true&page=' + page + filter).then((res) => {
				this.archiveUsers = res.data.response;
				this.isLoadingArchive = false;
				if (!this.archiveUsers.data.length) {
					this.noRecordArchive = true;
					if (page > 1) {
						this.getArchiveUsers(page - 1);
					}
				}
			});
		},
		getLocations() {
			axios.get('admin/locations').then((res) => {
				this.locations = res.data.response;
			});
		},
		getBuildingsAssigned(location_id) {
			let filter = '&location_id=' + location_id;
			axios
				.get('admin/buildings?pagination=false' + filter)
				.then((res) => {
					this.buildingsAssigned = res.data.response;
				})
				.catch((err) => {
					if (err.response) {
						if (err.response.status == 401) {
							this.logout();
						}
					}
				});
		},
		getBuildingsUnAssigned(location_id) {
			let filter = '&location_id=' + location_id;
			axios
				.get('admin/buildings?pagination=false' + filter)
				.then((res) => {
					this.buildingsUnAssigned = res.data.response;
				})
				.catch((err) => {
					if (err.response) {
						if (err.response.status == 401) {
							this.logout();
						}
					}
				});
		},
		getBuildingsInActive(location_id) {
			let filter = '&location_id=' + location_id;
			axios
				.get('admin/buildings?pagination=false' + filter)
				.then((res) => {
					this.buildingsInActive = res.data.response;
				})
				.catch((err) => {
					if (err.response) {
						if (err.response.status == 401) {
							this.logout();
						}
					}
				});
		},
		getBuildingsArchived(location_id) {
			let filter = '&location_id=' + location_id;
			axios
				.get('admin/buildings?pagination=false' + filter)
				.then((res) => {
					this.buildingsArchived = res.data.response;
				})
				.catch((err) => {
					if (err.response) {
						if (err.response.status == 401) {
							this.logout();
						}
					}
				});
		},
		searchOptionAssignUser(event) {
			this.searchFormAssignUser = {
				username: null,
				email: null,
				location: null,
				user_type_id: null,
			};
			let selectedValue = event.target.value;
			if (selectedValue == '') {
				this.resetSearchAssignUser();
			}
			if (selectedValue == 'name') {
				this.isName = true;
				this.isLocation = false;
				this.isUserType = false;
				this.isSearching = true;
			}
			if (selectedValue == 'location') {
				this.isName = false;
				this.isLocation = true;
				this.isUserType = false;
				this.isSearching = true;
			}
			if (selectedValue == 'usertype') {
				this.isName = false;
				this.isLocation = false;
				this.isUserType = true;
				this.isSearching = true;
			}
		},
		searchAssignUser() {
			this.getAssignedUsers();
		},
		resetSearchAssignUser() {
			this.searchFormAssignUser = {
				username: null,
				email: null,
				location: null,
				user_type_id: null,
			};
			this.isName = false;
			this.isLocation = false;
			this.isUserType = false;
			this.isSearching = false;
			this.searchByAssignedUser = '';
			this.hasAssignedSearched = false;
			this.assignedUsers = {};
			this.noRecord = false;
		},
		searchOptionUnAssignUser(event) {
			this.searchFormUnAssignUser = {
				username: null,
				email: null,
				location: null,
				user_type_id: null,
			};
			let selectedValue = event.target.value;
			if (selectedValue == '') {
				this.resetSearchUnAssignUser();
			}
			if (selectedValue == 'name') {
				this.isNameUnAssigned = true;
				this.isLocationUnAssigned = false;
				this.isUserTypeUnAssigned = false;
				this.isSearchingUnAssigned = true;
			}
			if (selectedValue == 'location') {
				this.isNameUnAssigned = false;
				this.isLocationUnAssigned = true;
				this.isUserTypeUnAssigned = false;
				this.isSearchingUnAssigned = true;
			}
			if (selectedValue == 'usertype') {
				this.isNameUnAssigned = false;
				this.isLocationUnAssigned = false;
				this.isUserTypeUnAssigned = true;
				this.isSearchingUnAssigned = true;
			}
		},
		searchUnAssignUser() {
			this.getUnAssignedUsers();
		},
		resetSearchUnAssignUser() {
			this.searchFormUnAssignUser = {
				username: null,
				email: null,
				location: null,
				user_type_id: null,
			};
			this.isNameUnAssigned = false;
			this.isLocationUnAssigned = false;
			this.isUserTypeUnAssigned = false;
			this.isSearchingUnAssigned = false;
			this.searchByUnAssignedUser = '';
			this.hasUnAssignedSearched = false;
			this.unAssignedUsers = {};
			this.noRecordUnAssignedUser = false;
		},
		searchOptionInActiveUser(event) {
			this.searchFormInActiveUser = {
				username: null,
				email: null,
				location: null,
				user_type_id: null,
				application_status: null,
			};
			let selectedValue = event.target.value;
			if (selectedValue == '') {
				this.resetSearchInActiveUser();
			}
			if (selectedValue == 'name') {
				this.isNameInActive = true;
				this.isLocationInActive = false;
				this.isUserTypeInActive = false;
				this.isSearchingInActive = true;
			}
			if (selectedValue == 'location') {
				this.isNameInActive = false;
				this.isLocationInActive = true;
				this.isUserTypeInActive = false;
				this.isSearchingInActive = true;
			}
			if (selectedValue == 'usertype') {
				this.isNameInActive = false;
				this.isLocationInActive = false;
				this.isUserTypeUnAssigned = true;
				this.isSearchingInActive = true;
			}
		},
		searchInActiveUser() {
			this.getInActiveUsers();
		},
		resetSearchInActiveUser() {
			this.searchFormInActiveUser = {
				username: null,
				email: null,
				location: null,
				user_type_id: null,
				application_status: null,
			};
			this.isNameUnAssigned = false;
			this.isLocationUnAssigned = false;
			this.isUserTypeUnAssigned = false;
			this.isSearchingUnAssigned = false;
			this.searchByUnAssignedUser = '';
			this.hasInActiveSearched = false;
			this.inActiveUsers = {};
			this.noRecordInActiveUser = false;
		},
		searchArchiveUser() {
			this.getArchiveUsers();
		},
		resetSearchArchiveUser() {
			this.searchFormArchiveUser = {
				username: null,
				email: null,
				location: null,
				user_type_id: null,
				user_status_id: null,
			};
			this.hasArchiveSearched = false;
			this.archiveUsers = {};
			this.noRecordArchive = false;
		},
		sortAssign(key) {
			this.assignSort.isSorted = true;
			if (this.assignSort.sortValue == null) {
				this.assignSort.sortValue = 'asc';
			} else if (this.assignSort.sortValue == 'asc') {
				this.assignSort.sortValue = 'desc';
			} else {
				this.assignSort.sortValue = null;
				this.assignSort.isSorted = false;
			}

			this.assignSort.sortKey = key;

			this.getAssignedUsers();
		},
		sortUnAssign(key) {
			this.unAssignSort.isSorted = true;
			if (this.unAssignSort.sortValue == null) {
				this.unAssignSort.sortValue = 'asc';
			} else if (this.unAssignSort.sortValue == 'asc') {
				this.unAssignSort.sortValue = 'desc';
			} else {
				this.unAssignSort.sortValue = null;
				this.unAssignSort.isSorted = false;
			}

			this.unAssignSort.sortKey = key;

			this.getUnAssignedUsers();
		},
		sortInActive(key) {
			this.inActiveSort.isSorted = true;
			if (this.inActiveSort.sortValue == null) {
				this.inActiveSort.sortValue = 'asc';
			} else if (this.inActiveSort.sortValue == 'asc') {
				this.inActiveSort.sortValue = 'desc';
			} else {
				this.inActiveSort.sortValue = null;
				this.inActiveSort.isSorted = false;
			}

			this.inActiveSort.sortKey = key;

			this.getInActiveUsers();
		},
		sortArchive(key) {
			this.archiveSort.isSorted = true;
			if (this.archiveSort.sortValue == null) {
				this.archiveSort.sortValue = 'asc';
			} else if (this.archiveSort.sortValue == 'asc') {
				this.archiveSort.sortValue = 'desc';
			} else {
				this.archiveSort.sortValue = null;
				this.archiveSort.isSorted = false;
			}

			this.archiveSort.sortKey = key;

			this.getArchiveUsers();
		},
		getFullName(user) {
			let fullname = '';
			if (user.first_name && user.first_name.length) {
				fullname += user.first_name;
			}
			if (user.last_name && user.last_name.length) {
				fullname += ' ' + user.last_name;
			}
			return fullname;
		},
		openInPopupWindow(path) {
			let component = this;
			if (path) {
				let route = component.$router.resolve({ path: path });
				window.open(route.href, '_blank', 'location=yes,scrollbars=yes,status=yes');
			}
		},
	},
	computed: {
		userTypesSelectorOptions() {
			let component = this;
			/**
			 * 1: Admin
			 * 6: MVS Coordinator
			 * 7: Client Care Manager
			 * 8: Recovery Coach Supervisor
			 * 9: Assistant
			 */
			let userRoles = [
				{ value: '4', text: 'Volunteer', allowedFor: [1, 9, 8, 6] },
				{ value: '3', text: 'Mentor', allowedFor: [1, 9, 7, 6] },
				{ value: '11', text: 'Mentor/Volunteer', allowedFor: [1, 9, 7, 8] },
			];

			if (!component.currentUserData || !component.currentUserData.user_type_id) {
				return userRoles;
			}

			let filteredOptions = [];
			userRoles.forEach(function (x) {
				if (x.allowedFor.includes(component.currentUserData.user_type_id)) {
					filteredOptions.push(x);
				}
			});

			return filteredOptions;
		},
	},
};
</script>

<style scoped>
.btn-find {
	font-family: var(--bs-body-font-family) !important;
}

.sortable {
	position: relative;
	cursor: pointer;
}

.sortable .fa {
	position: absolute;
	right: 30px;
	top: 15px;
}
</style>

<template>
	<Layout>
		<PageHeader :title="title" :items="items" />

		<div class="row">
			<div class="col-lg-12">
				<div class="card">
					<div class="card-body">
						<h4 class="card-title">Resources</h4>

						<b-tabs justified nav-class="nav-tabs-custom" content-class="p-3 text-muted">
							<!-- Assigned -->
							<b-tab active class="border-0">
								<template v-slot:title>
									<span class="d-inline-block d-sm-none">
										<i class="fas fa-home"></i>
									</span>
									<span class="d-none d-sm-inline-block">Assigned</span>
								</template>

								<form class="row align-items-center form-inline mb-4 border p-3 m-0" @submit.prevent="searchAssignUser">
									<div class="col-md-3">
										<label>User Name</label>
										<input v-model="searchFormAssignUser.username" type="text" class="ps-4 form-control" placeholder="Type User Name" :disabled="isLoading" />
									</div>
									<div class="col-md-3">
										<label>Email</label>
										<input v-model="searchFormAssignUser.email" type="text" class="ps-4 form-control" placeholder="Type Email Address" :disabled="isLoading" />
									</div>
									<div class="col-md-2">
										<label>Location</label>
										<b-form-select class="form-select" v-model="searchFormAssignUser.location" :options="locations" value-field="id" text-field="name" @change="getBuildingsAssigned($event)" :disabled="isLoading">
											<option slot="first" :value="null">-- All Locations --</option>
										</b-form-select>
									</div>
									<div class="col-md-2">
										<label>Building</label>
										<b-form-select class="form-select" v-model="searchFormAssignUser.building" :options="buildingsAssigned" value-field="id" text-field="name" :disabled="isLoading">
											<option slot="first" :value="null">-- All Buildings --</option>
										</b-form-select>
									</div>
									<div class="col-md-2">
										<label>User Type</label>

										<b-form-select class="form-select" v-model="searchFormAssignUser.user_type_id" :options="userTypesSelectorOptions" :disabled="isLoading">
											<option slot="first" :value="null" selected>-- All User Types --</option>
										</b-form-select>
									</div>
									<div class="col-md-3"></div>
									<div class="col-md-3"></div>
									<div class="col-md-3 d-grid">
										<label>&nbsp;</label>
										<button type="button" @click="resetSearchAssignUser" class="btn btn-block btn-light"><i class="bx bx-reset"></i> Reset</button>
									</div>
									<div class="col-md-3 d-grid">
										<label>&nbsp;</label>
										<button type="submit" class="btn btn-block btn-primary" :disabled="isLoading"><i class="bx bx-search-alt-2"></i> Search</button>
									</div>
								</form>

								<div class="table-responsive">
									<table class="table table-bordered table-hover table-striped align-middle mb-0">
										<thead class="table-light">
											<tr>
												<th scope="col" class="sortable" @click="sortAssign('users.first_name')">
													Name
													<i v-if="assignSort.sortKey == 'users.first_name' && assignSort.sortValue == 'asc'" class="fa fa-sort-down"></i>
													<i v-else-if="assignSort.sortKey == 'users.first_name' && assignSort.sortValue == 'desc'" class="fa fa-sort-up"></i>
													<i v-else class="fa fa-sort"></i>
												</th>
												<th scope="col" class="sortable" @click="sortAssign('locations.name')">
													Location
													<i v-if="assignSort.sortKey == 'locations.name' && assignSort.sortValue == 'asc'" class="fa fa-sort-down"></i>
													<i v-else-if="assignSort.sortKey == 'locations.name' && assignSort.sortValue == 'desc'" class="fa fa-sort-up"></i>
													<i v-else class="fa fa-sort"></i>
												</th>
												<th scope="col">Building</th>
												<th scope="col">Status</th>
												<th scope="col">Type</th>
												<th scope="col">Assigned To</th>
												<th scope="col" class="sortable" @click="sortAssign('users.assignment_date')">
													Assignment Date
													<i v-if="assignSort.sortKey == 'users.assignment_date' && assignSort.sortValue == 'asc'" class="fa fa-sort-down"></i>
													<i v-else-if="assignSort.sortKey == 'users.assignment_date' && assignSort.sortValue == 'desc'" class="fa fa-sort-up"></i>
													<i v-else class="fa fa-sort"></i>
												</th>
											</tr>
										</thead>
										<tbody>
											<tr v-if="isLoading">
												<td colspan="7" class="text-center p-0">
													<b-spinner class="m-2" variant="primary" role="status"></b-spinner>
												</td>
											</tr>

											<tr v-else-if="noRecord">
												<td colspan="7" class="p-0">
													<p class="font-size-16 text-center my-3">Record Not Found!</p>
												</td>
											</tr>

											<tr v-else-if="hasAssignedSearched == false && !(assignedUsers && assignedUsers.data && assignedUsers.data.length > 0)">
												<td colspan="7" class="p-0">
													<p class="font-size-16 text-center my-3">
														Use the filters above to search for users.
													</p>
												</td>
											</tr>

											<tr v-show="assignedUsers" v-for="(assignedUser, assignedUserIndex) in assignedUsers.data" :key="assignedUserIndex">
												<td>
													<h5 class="font-size-13 text-truncate mb-1">
														<router-link tag="a" :to="`/registration-progress/user/${assignedUser.user_id}`" target="_blank"> {{ getFullName(assignedUser) }} </router-link>
													</h5>
												</td>
												<td>
													<p class="text-muted mb-0 text-wrap">
														{{ assignedUser.location }}
													</p>
												</td>
												<td>
													<p class="text-muted mb-0 text-wrap" v-if="assignedUser">
														{{ assignedUser.building != null ? assignedUser.building : 'N/A' }}
													</p>
												</td>
												<td>
													<p class="text-muted mb-0 text-wrap">
														{{ assignedUser.status }}
													</p>
												</td>
												<td>
													<p class="text-muted mb-0 text-wrap">
														{{ assignedUser.UserType }}
													</p>
												</td>
												<td>
													<p class="font-size-13 text-truncate mb-1">
														{{ assignedUser.role_name }}
													</p>
												</td>
												<td>
													<p class="text-muted mb-0 text-wrap">
														{{ dateForatter(assignedUser.approval_date) }}
													</p>
												</td>
											</tr>
										</tbody>
									</table>
								</div>

								<pagination class="mt-4" :data="assignedUsers" :limit="10" @pagination-change-page="getAssignedUsers"></pagination>
							</b-tab>
							<!-- UnAssigned -->
							<b-tab>
								<template v-slot:title>
									<span class="d-inline-block d-sm-none">
										<i class="far fa-user"></i>
									</span>
									<span class="d-none d-sm-inline-block">UnAssigned</span>
								</template>

								<form class="row align-items-center form-inline mb-4 border p-3 m-0" @submit.prevent="searchUnAssignUser">
									<div class="col-md-3">
										<label>User Name</label>
										<input v-model="searchFormUnAssignUser.username" type="text" class="ps-4 form-control" placeholder="Type User Name" :disabled="isLoadingUnAssignedUser" />
									</div>
									<div class="col-md-3">
										<label>Email</label>
										<input v-model="searchFormUnAssignUser.email" type="text" class="ps-4 form-control" placeholder="Type Email Address" :disabled="isLoadingUnAssignedUser" />
									</div>
									<div class="col-md-2">
										<label>Location</label>
										<b-form-select class="form-select" v-model="searchFormUnAssignUser.location" :options="locations" value-field="id" text-field="name" @change="getBuildingsUnAssigned($event)" :disabled="isLoadingUnAssignedUser">
											<option slot="first" :value="null">-- All Locations --</option>
										</b-form-select>
									</div>
									<div class="col-md-2">
										<label>Building</label>
										<b-form-select class="form-select" v-model="searchFormUnAssignUser.building" :options="buildingsUnAssigned" value-field="id" text-field="name" :disabled="isLoadingUnAssignedUser">
											<option slot="first" :value="null">-- All Buildings --</option>
										</b-form-select>
									</div>
									<div class="col-md-2">
										<label>User Type</label>
										<b-form-select class="form-select" v-model="searchFormUnAssignUser.user_type_id" :options="userTypesSelectorOptions" :disabled="isLoadingUnAssignedUser">
											<option slot="first" :value="null">-- All User Types --</option>
										</b-form-select>
									</div>
									<div class="col-md-3"></div>
									<div class="col-md-3"></div>
									<div class="col-md-3 d-grid">
										<label>&nbsp;</label>
										<button type="button" @click="resetSearchUnAssignUser" class="btn btn-block btn-light"><i class="bx bx-reset"></i> Reset</button>
									</div>
									<div class="col-md-3 d-grid">
										<label>&nbsp;</label>
										<button type="submit" class="btn btn-block btn-primary" :disabled="isLoadingUnAssignedUser"><i class="bx bx-search-alt-2"></i> Search</button>
									</div>
								</form>

								<div class="table-responsive">
									<table class="table table-bordered table-hover table-striped align-middle mb-0">
										<thead class="table-light">
											<tr>
												<th scope="col" class="sortable" @click="sortUnAssign('users.first_name')">
													Name
													<i v-if="unAssignSort.sortKey == 'users.first_name' && unAssignSort.sortValue == 'asc'" class="fa fa-sort-down"></i>
													<i v-else-if="unAssignSort.sortKey == 'users.first_name' && unAssignSort.sortValue == 'desc'" class="fa fa-sort-up"></i>
													<i v-else class="fa fa-sort"></i>
												</th>
												<th scope="col" class="sortable" @click="sortUnAssign('locations.name')">
													Location
													<i v-if="unAssignSort.sortKey == 'locations.name' && unAssignSort.sortValue == 'asc'" class="fa fa-sort-down"></i>
													<i v-else-if="unAssignSort.sortKey == 'locations.name' && unAssignSort.sortValue == 'desc'" class="fa fa-sort-up"></i>
													<i v-else class="fa fa-sort"></i>
												</th>
												<th scope="col">Building</th>
												<th scope="col">Status</th>
												<th scope="col">Type</th>
												<th scope="col">Assigned To</th>
												<th scope="col">Application Date</th>
											</tr>
										</thead>
										<tbody>
											<tr v-if="isLoadingUnAssignedUser">
												<td colspan="7" class="text-center p-0">
													<b-spinner class="m-2" variant="primary" role="status"></b-spinner>
												</td>
											</tr>

											<tr v-else-if="noRecordUnAssignedUser">
												<td colspan="7" class="p-0">
													<p class="font-size-16 text-center my-3">Record Not Found!</p>
												</td>
											</tr>

											<tr v-else-if="hasUnAssignedSearched == false && !(unAssignedUsers && unAssignedUsers.data && unAssignedUsers.data.length > 0)">
												<td colspan="7" class="p-0">
													<p class="font-size-16 text-center my-3">
														Use the filters above to search for users.
													</p>
												</td>
											</tr>

											<tr v-show="unAssignedUsers" v-for="(unAssignedUser, unAssignedUserIndex) in unAssignedUsers.data" :key="unAssignedUserIndex">
												<td>
													<router-link tag="a" :to="`/registration-progress/user/${unAssignedUser.user_id}`" target="_blank"> {{ getFullName(unAssignedUser) }} </router-link>
												</td>
												<td>
													<p class="text-muted mb-0 text-wrap">
														{{ unAssignedUser.location }}
													</p>
												</td>
												<td>
													<p class="text-muted mb-0 text-wrap">
														<span v-if="unAssignedUser.user_type_id == 4">{{ unAssignedUser.building != null ? unAssignedUser.building : 'N/A' }}</span>
														<span v-if="unAssignedUser.user_type_id == 3">{{ unAssignedUser.buildings != '' ? unAssignedUser.buildings : 'N/A' }}</span>
													</p>
												</td>
												<td>
													<p class="mb-0 text-wrap text-danger">
														{{ unAssignedUser.status }}
													</p>
												</td>
												<td>
													<p class="text-muted mb-0 text-wrap">
														{{ unAssignedUser.UserType }}
													</p>
												</td>
												<td>
													<p class="text-muted mb-0 text-wrap">
														{{ unAssignedUser.role_name != null ? unAssignedUser.role_name : 'N/A' }}
													</p>
												</td>
												<td>
													<p class="text-muted mb-0 text-wrap">
														{{ dateForatter(unAssignedUser.approval_date) }}
													</p>
												</td>
											</tr>
										</tbody>
									</table>
								</div>

								<pagination class="mt-4" :data="unAssignedUsers" :limit="10" @pagination-change-page="getUnAssignedUsers"></pagination>
							</b-tab>
							<!-- In Process -->
							<b-tab>
								<template v-slot:title>
									<span class="d-inline-block d-sm-none">
										<i class="far fa-user"></i>
									</span>
									<span class="d-none d-sm-inline-block">In Process</span>
								</template>

								<form class="row align-items-center form-inline mb-4 border p-3 m-0" @submit.prevent="searchInActiveUser">
									<div class="col-md-3">
										<label>User Name</label>
										<input v-model="searchFormInActiveUser.username" type="text" class="ps-4 form-control" placeholder="Type User Name" :disabled="isLoadingInActiveUser" />
									</div>
									<div class="col-md-3">
										<label>Email</label>
										<input v-model="searchFormInActiveUser.email" type="text" class="ps-4 form-control" placeholder="Type Email Address" :disabled="isLoadingInActiveUser" />
									</div>
									<div class="col-md-2">
										<label>Location</label>
										<b-form-select class="form-select" v-model="searchFormInActiveUser.location" :options="locations" value-field="id" text-field="name" :disabled="isLoadingInActiveUser">
											<option slot="first" :value="null">-- All Locations --</option>
										</b-form-select>
									</div>
									<div class="col-md-2">
										<label>Application Status</label>
										<b-form-select class="form-select" v-model="searchFormInActiveUser.application_status" :options="applicationStatuses" value-field="value" text-field="text" :disabled="isLoadingInActiveUser">
											<option slot="first" :value="null">-- All Statuses --</option>
										</b-form-select>
									</div>

									<div class="col-md-2">
										<label>User Type</label>
										<b-form-select class="form-select" v-model="searchFormInActiveUser.user_type_id" :options="userTypesSelectorOptions" :disabled="isLoadingInActiveUser">
											<option slot="first" :value="null">-- All User Types --</option>
										</b-form-select>
									</div>
									<div class="col-md-3"></div>
									<div class="col-md-3"></div>
									<div class="col-md-3 d-grid">
										<label>&nbsp;</label>
										<button type="button" @click="resetSearchInActiveUser" class="btn btn-block btn-light"><i class="bx bx-reset"></i> Reset</button>
									</div>
									<div class="col-md-3 d-grid">
										<label>&nbsp;</label>
										<button type="submit" class="btn btn-block btn-primary" :disabled="isLoadingInActiveUser"><i class="bx bx-search-alt-2"></i> Search</button>
									</div>
								</form>

								<div class="table-responsive">
									<table class="table table-bordered table-hover table-striped align-middle mb-0">
										<thead class="table-light">
											<tr>
												<th scope="col" class="sortable" @click="sortInActive('users.first_name')">
													Name
													<i v-if="inActiveSort.sortKey == 'users.first_name' && inActiveSort.sortValue == 'asc'" class="fa fa-sort-down"></i>
													<i v-else-if="inActiveSort.sortKey == 'users.first_name' && inActiveSort.sortValue == 'desc'" class="fa fa-sort-up"></i>
													<i v-else class="fa fa-sort"></i>
												</th>
												<th scope="col" class="sortable" @click="sortInActive('locations.name')">
													Location
													<i v-if="inActiveSort.sortKey == 'locations.name' && inActiveSort.sortValue == 'asc'" class="fa fa-sort-down"></i>
													<i v-else-if="inActiveSort.sortKey == 'locations.name' && inActiveSort.sortValue == 'desc'" class="fa fa-sort-up"></i>
													<i v-else class="fa fa-sort"></i>
												</th>
												<th scope="col">Building</th>
												<th scope="col">Status</th>
												<th scope="col">Application Status</th>
												<th scope="col">Type</th>
												<th scope="col">Assigned To</th>
												<th scope="col">Application Date</th>
											</tr>
										</thead>
										<tbody>
											<tr v-if="isLoadingInActiveUser">
												<td colspan="8" class="text-center p-0">
													<b-spinner class="m-2" variant="primary" role="status"></b-spinner>
												</td>
											</tr>

											<tr v-else-if="noRecordInActiveUser">
												<td colspan="8" class="p-0">
													<p class="font-size-16 text-center my-3">Record Not Found!</p>
												</td>
											</tr>

											<tr v-else-if="hasInActiveSearched == false && !(inActiveUsers && inActiveUsers.data && inActiveUsers.data.length > 0)">
												<td colspan="8" class="p-0">
													<p class="font-size-16 text-center my-3">
														Use the filters above to search for users.
													</p>
												</td>
											</tr>

											<tr v-show="inActiveUsers" v-for="(inActiveUsers, inActiveUserIndex) in inActiveUsers.data" :key="inActiveUserIndex">
												<td>
													<router-link tag="a" :to="`/registration-progress/user/${inActiveUsers.user_id}`" target="_blank"> {{ getFullName(inActiveUsers) }} </router-link>
												</td>
												<td>
													<p class="text-muted mb-0 text-wrap">
														{{ inActiveUsers.location }}
													</p>
												</td>
												<td>
													<p class="text-muted mb-0 text-wrap">
														{{ inActiveUsers.building != null ? inActiveUsers.building : 'N/A' }}
													</p>
												</td>
												<td>
													<p class="mb-0 text-wrap text-danger">
														{{ inActiveUsers.status }}
													</p>
												</td>

												<td>
													<p class="mb-0 text-wrap">
														{{ inActiveUsers.user_current_status }}
													</p>
												</td>

												<td>
													<p class="text-muted mb-0 text-wrap">
														{{ inActiveUsers.UserType }}
													</p>
												</td>
												<td>
													<p class="text-muted mb-0 text-wrap">
														{{ inActiveUsers.role_name != null ? inActiveUsers.role_name : 'N/A' }}
													</p>
												</td>
												<td>
													<p class="text-muted mb-0 text-wrap">
														{{ dateForatter(inActiveUsers.approval_date) }}
													</p>
												</td>
											</tr>
										</tbody>
									</table>
								</div>

								<pagination class="mt-4" :data="inActiveUsers" :limit="10" @pagination-change-page="getInActiveUsers"></pagination>
							</b-tab>
							<!-- InActive  -->
							<b-tab>
								<template v-slot:title>
									<span class="d-inline-block d-sm-none">
										<i class="far fa-user"></i>
									</span>
									<span class="d-none d-sm-inline-block">InActive and UnAssigned</span>
								</template>

								<form class="form-inline mb-4 border p-3 m-0" @submit.prevent="searchArchiveUser">
									<div class="row align-items-center">
										<div class="col-md-3">
											<label>User Name</label>
											<input v-model="searchFormArchiveUser.username" type="text" class="ps-4 form-control" placeholder="Type User Name" :disabled="isLoadingArchive" />
										</div>
										<div class="col-md-3">
											<label>Email</label>
											<input v-model="searchFormArchiveUser.email" type="text" class="ps-4 form-control" placeholder="Type Email Address" :disabled="isLoadingArchive" />
										</div>
										<div class="col-md-2">
											<label>Location</label>
											<b-form-select class="form-select" v-model="searchFormArchiveUser.location" :options="locations" value-field="id" text-field="name" :disabled="isLoadingArchive">
												<option slot="first" :value="null">-- All Locations --</option>
											</b-form-select>
										</div>
										<div class="col-md-2">
											<label>User Type</label>
											<b-form-select class="form-select" v-model="searchFormArchiveUser.user_type_id" :options="userTypesSelectorOptions" :disabled="isLoadingArchive">
												<option slot="first" :value="null">-- All User Types --</option>
											</b-form-select>
										</div>
										<div class="col-md-2">
											<label>User Status</label>
											<b-form-select class="form-select" v-model="searchFormArchiveUser.user_status_id" :options="profileStatuses" :disabled="isLoadingArchive">
												<option slot="first" :value="null">-- All User Statuses --</option>
											</b-form-select>
										</div>
									</div>

									<div class="row align-items-center">
										<div class="col-md-3 offset-6 d-grid">
											<label>&nbsp;</label>
											<button type="button" @click="resetSearchArchiveUser" class="btn btn-block btn-light"><i class="bx bx-reset"></i> Reset</button>
										</div>
										<div class="col-md-3 d-grid">
											<label>&nbsp;</label>
											<button type="submit" class="btn btn-block btn-primary" :disabled="isLoadingArchive"><i class="bx bx-search-alt-2"></i> Search</button>
										</div>
									</div>
								</form>

								<div class="table-responsive">
									<table class="table table-bordered table-hover table-striped align-middle mb-0">
										<thead class="table-light">
											<tr>
												<th scope="col" class="sortable" @click="sortArchive('users.first_name')">
													Name
													<i v-if="archiveSort.sortKey == 'users.first_name' && archiveSort.sortValue == 'asc'" class="fa fa-sort-down"></i>
													<i v-else-if="archiveSort.sortKey == 'users.first_name' && archiveSort.sortValue == 'desc'" class="fa fa-sort-up"></i>
													<i v-else class="fa fa-sort"></i>
												</th>
												<th scope="col" class="sortable" @click="sortArchive('locations.name')">
													Location
													<i v-if="archiveSort.sortKey == 'locations.name' && archiveSort.sortValue == 'asc'" class="fa fa-sort-down"></i>
													<i v-else-if="archiveSort.sortKey == 'locations.name' && archiveSort.sortValue == 'desc'" class="fa fa-sort-up"></i>
													<i v-else class="fa fa-sort"></i>
												</th>
												<th scope="col">Status</th>
												<th scope="col">Type</th>
												<th scope="col">Application Date</th>
											</tr>
										</thead>
										<tbody>
											<tr v-if="isLoadingArchive">
												<td colspan="5" class="text-center p-0">
													<b-spinner class="m-2" variant="primary" role="status"></b-spinner>
												</td>
											</tr>

											<tr v-else-if="noRecordArchive">
												<td colspan="5" class="p-0">
													<p class="font-size-16 text-center my-3">Record Not Found!</p>
												</td>
											</tr>

											<tr v-else-if="hasArchiveSearched == false && !(archiveUsers && archiveUsers.data && archiveUsers.data.length > 0)">
												<td colspan="5" class="p-0">
													<p class="font-size-16 text-center my-3">Use the filters above to search for users.</p>
												</td>
											</tr>


											<tr v-show="archiveUsers" v-for="(archiveUsers, archiveUsersIndex) in archiveUsers.data" :key="archiveUsersIndex">
												<td>
													<router-link tag="a" :to="`/registration-progress/user/${archiveUsers.user_id}`" target="_blank"> {{ getFullName(archiveUsers) }} </router-link>
												</td>
												<td>
													<p class="text-muted mb-0 text-wrap">
														{{ archiveUsers.location }}
													</p>
												</td>
												<td>
													<p class="mb-0 text-wrap text-danger">
														{{ archiveUsers.status }}
													</p>
												</td>
												<td>
													<p class="text-muted mb-0 text-wrap">
														{{ archiveUsers.UserType }}
													</p>
												</td>
												<td>
													<p class="text-muted mb-0 text-wrap">
														{{ dateForatter(archiveUsers.approval_date) }}
													</p>
												</td>
											</tr>
										</tbody>
									</table>
								</div>

								<pagination class="mt-4" :data="archiveUsers" :limit="10" @pagination-change-page="getArchiveUsers"></pagination>
							</b-tab>
						</b-tabs>
					</div>
				</div>
			</div>
		</div>
	</Layout>
</template>

<style scoped>
.app-search input,
.app-search select {
	border-top-right-radius: 0px;
	border-bottom-right-radius: 0px;
}

.app-search .btn-find {
	width: 40%;
	border-top-right-radius: 30px;
	border-bottom-right-radius: 30px;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 15px;
	box-shadow: none;
}

.app-search .btn-reset {
	width: 40%;
	font-size: 15px;
	box-shadow: none;
	border-radius: 30px;
}
</style>
